var React = require('react');
var toastr = require('toastr');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');
var Button = require('react-bootstrap/lib/Button');
var Select = require('react-bootstrap/lib/SplitButton');
var Option = require('react-bootstrap/lib/MenuItem');

var style = {
	textarea: {
		width: "100%",
		height: "200px"	
	},

	nextButton: {
		width: "200px",
		color: '#fff',
		marginTop: '15px',
		backgroundColor: '#03a6dc',
		borderColor: '#03a6dc'		
	}
};

var Push = React.createClass({

	getInitialState: function() {
		return {
			channel: '0',
			value: ''
		}
	},

	componentWillMount: function() {
		this.props.load();
	},

	componentWillUnmount: function() {
		this.props.unload();
	},

	componentWillReceiveProps: function(nextProps) {
		this.setState(nextProps.push);
	},

	channelUpdate: function(data) {
		this.setState({ channel: data.channel });
	},

	getTitleChannel: function(status) {
		var label;

		if(status == 1) {
			label = 'Clientes';
		} else {
			label = 'Entregadores';
		}

		return label;
	},

	valueChange: function(event) {
		this.setState({ value: event.target.value});
	},

	send: function() {
		if(this.state.value != null && this.state.value != '') {
			this.sendNotification();
		}
	},

	sendNotification: function() {
		var notification = {};
		notification["body"] = this.state.value;
		notification["title"] = this.state.channel == 1 ? "Ajato" : "Ajato Entregas";
		notification["sound"] = 'default';

		var data = {};
		data["to"] = this.state.channel == 1 ? "/topics/clients" : "/topics/couriers";
		data["priority"] = "high";
		data["notification"] = notification;

		fetch('https://android.googleapis.com/gcm/send', {
			method: 'POST',
			headers: {
				'Authorization': 'key=AAAA5C4I-e4:APA91bFepe-FC4_lGFT90TT4wpyjTOHnmoMhgqFqLCEqLthZ0bKZDV9QzabigR3rxRwi6B6EuATLQBVUN32-RrLLPDs31Bka4R4tERXkPclxvp1W6CwhDJaGKqL2xh6_LEClu5f7dOdx', //Produção
				//'Authorization': 'key=AAAAwyxREIQ:APA91bEUDysKbFX4sC7Uu2rpfI4CDVFB0wJNsW2RWu1bEL3Uk4g_5yA2YSkGf9FbfC8zpivI9OTSrKf9u-qrHVSFQmMEm6yik8TCS8irbPaqc8Fc5tf8IjQaY_WxXougYyOm1wRigP8i', //Teste
				'Content-Type': 'application/json; charset=UTF-8',
			},
			body: JSON.stringify(data)
		}).then(response => response.json()).then(json => {
			this.setState({ value: ''});
	        toastr.success('Mensagem enviada com sucesso!');
	    }).catch(error => {
			toastr.error("Erro ao enviar, por favor tente novamente.");
		});
		toastr.success('Enviando... Por favor aguarde!');
	},

	render: function() {
		var me = this, push = me.props.push;
		
		return (
			<div style={{padding: '20px'}}>
				<ControlLabel>Enviar notificação para:</ControlLabel>
				<br/>
				<Select 
					bsStyle='default' 
					bsSize='xsmall' 
					title={me.getTitleChannel(me.state.channel)} 
					id={"channelSelect"}
				>
					<Option
						eventKey={{channel: 0}}
						onSelect={me.channelUpdate}
					>
						{"Entregadores"}
					</Option>
					<Option
						eventKey={{channel: 1}}
						onSelect={me.channelUpdate}
					>
						{"Clientes"}
					</Option>
				</Select>

				<br/>
				<br/>
				<ControlLabel>Texto:</ControlLabel>
				<br/>
				<textarea style={style.textarea}
					value={this.state.value}
					onChange={this.valueChange}
				/>

				<Button onClick={me.send} 
						block 
						bsStyle="default"
						style={style.nextButton}>
					{"Enviar"}
				</Button>
			</div>
		);
	}

});

module.exports = Push;


// WEBPACK FOOTER //
// ./src/components/Admin/Push.jsx